/**
 * Master-table asset type ids (tblCompany.AssetTypeId).
 * New Married Parents / Co-Parenting checks read assetTypeId only.
 * Existing name checks are left unchanged.
 */
export const MARRIED_PARENTS_ASSET_TYPE_ID = '5F8B0A24-A5A1-40C1-8F8A-E74B53BF251B';
export const CO_PARENTING_ASSET_TYPE_ID = '5DFCC522-2B70-4B44-A30E-3ED0129E676D';

const MASTER_ASSET_TYPE_IDS = {
    marriedparents: MARRIED_PARENTS_ASSET_TYPE_ID,
    marriedparent: MARRIED_PARENTS_ASSET_TYPE_ID,
    coparenting: CO_PARENTING_ASSET_TYPE_ID
};

function normalizeId(value) {
    return String(value || '').replace(/[{}]/g, '').trim().toLowerCase();
}

export function storedAssetTypeId() {
    return normalizeId(localStorage.getItem('assetTypeId') || localStorage.getItem('AssetTypeId'));
}

export function isMarriedParentsAssetTypeId() {
    return storedAssetTypeId() === MARRIED_PARENTS_ASSET_TYPE_ID.toLowerCase();
}

export function isCoParentingAssetTypeId() {
    return storedAssetTypeId() === CO_PARENTING_ASSET_TYPE_ID.toLowerCase();
}

export function isFamilyAssetTypeId() {
    return isMarriedParentsAssetTypeId() || isCoParentingAssetTypeId();
}

/**
 * Stores the master asset type id. The name is used only to look up that id.
 */
export function rememberAssetTypeId(assetTypeName, explicitId) {
    const explicit = String(explicitId || '').trim();
    if (explicit) {
        localStorage.setItem('assetTypeId', explicit);
        return explicit;
    }
    const key = String(
        assetTypeName
        || localStorage.getItem('assetType')
        || localStorage.getItem('AssetType')
        || ''
    ).trim().toLowerCase().replace(/[\s-]+/g, '');
    const id = MASTER_ASSET_TYPE_IDS[key];
    if (id) {
        localStorage.setItem('assetTypeId', id);
        return id;
    }
    return localStorage.getItem('assetTypeId') || '';
}

/** Assign-dropdown role labels. Other asset types are returned unchanged. */
function applyParentRoleLabels(value) {
    return value
        .replace(/\bfamily\s*admins\b/gi, 'Parents')
        .replace(/\bfamily\s*admin\b/gi, 'Parent')
        .replace(/\bcompany\s*admins\b/gi, 'Parents')
        .replace(/\bcompany\s*admin\b/gi, 'Parent')
        .replace(/\bco[\s-]?parents\b/gi, 'Parents')
        .replace(/\bco[\s-]?parent\b/gi, 'Parent')
        .replace(/\bco[\s-]?owners\b/gi, 'Parents')
        .replace(/\bco[\s-]?owner\b/gi, 'Parent')
        .replace(/\bmembers\b/gi, 'Parents')
        .replace(/\bmember\b/gi, 'Parent')
        .replace(/\bowners\b/gi, 'Parents')
        .replace(/\bowner\b/gi, 'Parent');
}

export function applyAssignDropdownRoleLabels(text) {
    const value = text == null ? '' : String(text);
    if (isMarriedParentsAssetTypeId() || isCoParentingAssetTypeId()) {
        return applyParentRoleLabels(value);
    }
    return value;
}
